import * as types from "../actions/actionTypes"
const initialState = {
  loading:true,
  error:false,
  data: { data: [], links: {}, message: [], meta: {} }
};

const OverallCostDetail = (state = initialState, action) => {
  switch (action.type) {
    case types.API_REMOVE_OVERALL_COST_DETAIL_REQUEST:
      return {...state, loading:true };
    case types.API_REMOVE_OVERALL_COST_DETAIL_SUCCESS:
      return {...state, ...action.payLoad};
    case types.API_REMOVE_OVERALL_COST_DETAIL_FAILURE:
      return { ...state, ...action.payLoad};
    case types.API_CALL_OVERALL_COST_DETAIL_REQUEST:
      return { ...state, loading: true, error: false };
    case types.PUT_OVERALL_COST_DETAIL:
      return { ...state, ...action.payLoad };
    default:
      return state;
  }
};

export default OverallCostDetail;